export default __webpack_public_path__ + "static/media/amazon-icon.8a708a0e.svg";